export const HOTEL_HOVERED = 'HOTEL_HOVERED';
